import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

// Valores de referencia usados como placeholder en el formulario de
// configuración, no como valor real precargado — cada bloque/cultivo tiene
// su propia configuración física y no debería asumirse ninguna por defecto.
export const HYDRAULIC_CONFIG_PLACEHOLDERS = {
    pulseDurationMinutes: 4,
    flowRatePerDripperCcMin: 20, // cc/minuto
    drippersPerMeter: 10,
    bedLengthMeters: 30,
    bedsPerLot: 50,
    dripLinesPerBed: 1,
};

const authHeaders = () => ({
    headers: { Authorization: 'Bearer ' + localStorage.getItem('user-jwt') },
});

export const getHydraulicConfig = async (cropId) => {
    try {
        const response = await axios.get(`${apiUrl}/crops/${cropId}/hydraulic-config`, {
            ...authHeaders(),
            validateStatus: (status) => status === 200 || status === 204,
        });
        return response.status === 204 ? null : response.data;
    } catch (error) {
        console.error(`Error al obtener configuración hidráulica del cultivo ${cropId}:`, error);
        throw error;
    }
};

// `applyToHistory` decide la vigencia (valid_from) de la nueva versión de la
// configuración en el backend: false = aplica solo desde hoy en adelante
// (los consumos ya calculados con la config anterior no cambian); true =
// aplica también a los pulsos ya registrados (corrige el histórico).
export const updateHydraulicConfig = async (cropId, config, applyToHistory = false) => {
    try {
        const response = await axios.put(
            `${apiUrl}/crops/${cropId}/hydraulic-config`,
            config,
            { ...authHeaders(), params: { applyToHistory } }
        );
        return response.data;
    } catch (error) {
        console.error(`Error al guardar configuración hidráulica del cultivo ${cropId}:`, error);
        throw error;
    }
};

// Rango por defecto al abrir la vista por primera vez: desde el primer pulso
// de riego registrado para el cultivo hasta hoy. No se ancla al ciclo de
// cultivo activo (puede estar finalizado, haber un hueco entre ciclos, o
// varios ciclos activos a la vez) — el riego es una medición física continua
// del bloque, independiente del ciclo de siembra.
export const getDefaultConsumptionRange = async (cropId) => {
    try {
        const response = await axios.get(
            `${apiUrl}/crops/${cropId}/water-consumption/default-range`,
            authHeaders()
        );
        return response.data; // { defaultStart, defaultEnd }
    } catch (error) {
        console.error(`Error al obtener el rango por defecto de consumo del cultivo ${cropId}:`, error);
        throw error;
    }
};

// Devuelve el consumo diario ya calculado en el backend: pulsos por día
// (sumados entre todos los sensores asociados al cultivo) y litros del
// bloque, usando la configuración hidráulica vigente en cada fecha.
export const getWaterConsumption = async (cropId, startDate, endDate) => {
    try {
        const response = await axios.get(`${apiUrl}/crops/${cropId}/water-consumption`, {
            ...authHeaders(),
            params: { startDate, endDate },
        });
        return response.data; // [{ date, pulseCount, liters }]
    } catch (error) {
        console.error(`Error al obtener el consumo de agua del cultivo ${cropId}:`, error);
        throw error;
    }
};
